module.exports = __webpack_public_path__ + "media/angular-engine/app/organization/accounts/empty-fb4fc5affece11263732306df17c64fb.png";